export default function FilterChip({
  'data-qa': dataQa,
  label,
  color,
  active,
  onClick,
}: {
  'data-qa': string;
  label: string;
  color?: string;
  active: boolean;
  onClick: () => void;
}) {
  return (
    <button
      data-qa={dataQa}
      type="button"
      aria-pressed={active}
      onClick={onClick}
      className={`flex items-center gap-1.5 rounded-lg border px-3 py-1.5 text-sm ${active ? 'border-agnes-primary bg-agnes-primary/10 text-agnes-primary' : 'border-agnes-border text-agnes-text hover:border-agnes-primary'}`}
    >
      {color && (
        <span
          data-qa={`${dataQa}-cor`}
          className="h-2 w-2 rounded-full"
          style={{ background: color }}
        />
      )}
      {label}
    </button>
  );
}
